import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RiSearchEyeLine } from "react-icons/ri";

const SearchComponent = ({ setSearchTerm }) => {
  const [input, setInput] = useState("");
  const { t } = useTranslation();

  const handleChange = (e) => {
    setInput(e.target.value);
    setSearchTerm(e.target.value);
  };

  return (
    <div
      style={{
        flex: "1 1 60%",
        minWidth: "250px",
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <div style={{ marginBottom: "30px", width: "100%" }}>
        <h4
          style={{
            fontSize: "1.25rem",
            color: "#34495e",
            marginBottom: "15px",
          }}
        >
          {t("blogsPage.searchBlogs")}
        </h4>
        <form
          onSubmit={(e) => e.preventDefault()}
          style={{
            display: "flex",
            gap: "10px",
          }}
        >
          <input
            type="search"
            placeholder={t("blogsPage.searchBlogs2")}
            value={input}
            onChange={handleChange}
            style={{
              padding: "10px",
              fontSize: "1rem",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />
          <button
            type="submit"
            style={{
              padding: "10px",
              fontSize: "1rem",
              backgroundColor: "var(--color-fourth)",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              width: "20%",
              maxWidth: "150px",
            }}
          >
            <RiSearchEyeLine fontSize={26} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default SearchComponent;
